var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4602 13.8744C12.8507 14.2649 13.4838 14.2649 13.8744 13.8744C14.2649 13.4838 14.2649 12.8507 13.8744 12.4602L8.74785 7.33364L13.8744 2.20712C14.2649 1.8166 14.2649 1.18343 13.8744 0.792908C13.4838 0.402383 12.8507 0.402383 12.4602 0.792908L7.33364 5.91942L2.20711 0.792893C1.81658 0.402369 1.18342 0.402369 0.792893 0.792893C0.402369 1.18342 0.402369 1.81658 0.792893 2.20711L5.91942 7.33364L0.792893 12.4602C0.402369 12.8507 0.402369 13.4839 0.792893 13.8744C1.18342 14.2649 1.81658 14.2649 2.20711 13.8744L7.33364 8.74785L12.4602 13.8744Z",
    fill: "#CC4232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.ee0301f5ce8fecebeb59cc7ef1f1cc35.svg";
export { ForwardRef as ReactComponent };